export function ExportQBCtrl (
  $scope,
  $translate,
  dateParsing,
  jsonApi,
  messages,
  sessionObjAPI,
  settings,
  types,
  workshopAPI
) {
  $scope.constraints = {};
  $scope.currency    = sessionObjAPI.currency();
  $scope.loaded      = true;
  $scope.recordTypes = types;
  $scope.settings    = settings;

  $scope.options     = {
    allow_previously_exported: false,
    begin_date               : '*',
    email_address            : sessionObjAPI.company().admin_email,
    end_date                 : '*',
    export_types             : [],
    ignore_imported          : false
  };

  $scope.export = function ( form ) {
    $scope.settings.qb_last_export_date = $scope.options.end_date;

    if (!$scope.options.export_types.length) {
      messages.show($translate.instant('JS_SPACE.QUICKBOOKS.SELECT_EXPORT_TYPE'), 'error');

      return;
    }

    workshopAPI.patch('/quickbooks/update_defaults', $scope.settings)
    .then(() => workshopAPI.post('/quickbooks/export', $scope.options))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.QUICKBOOKS.EXPORT_FILE_WILL_BE_EMAILED'), 'success');

      form.$setPristine();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.handleConstraintChange = function ( key, isActive ) {
    if (isActive) {
      $scope.options.export_types.push(key);
    }
    else {
      $scope.options.export_types = $scope.options.export_types.filter(type => type !== key);
    }
  };

  $scope.init = function () {
    $scope.options.begin_date = $scope.settings.qb_last_export_date
      ? dateParsing.tomorrow(settings.qb_last_export_date)
      : '*';

    $scope.initConstraints();
  };

  $scope.initConstraints = function () {
    $scope.recordTypes.forEach(type => {
      Object.entries(type)
      .forEach(([ key, value ]) => {
        $scope.constraints[value] = {
          label : key,
          active: true
        };

        $scope.options.export_types.push(value);
      });
    });
  };

  $scope.init();
}
